import { union } from 'lodash'
import OperatorExtension, { PhoneCallType } from 'store/slice/call-detail/types'

import { CategoryType } from '../lead-and-source-submission-form/types/category-type'

function sortOperators(_operators: OperatorExtension[]) {
  return [..._operators]?.sort((a, b) => {
    if (a.transferRate === null || a.transferRate === undefined) return 1
    if (b.transferRate === null || b.transferRate === undefined) return -1
    return a.transferRate - b.transferRate
  })
}

export const OrderOperators = (
  operators: OperatorExtension[],
  productTypes: CategoryType[],
  callType: PhoneCallType
) => {
  const selectedProductTypes = productTypes.filter((item) => item.isSelected)
  let positionLevel = 'کارشناس فروش'
  switch (callType) {
    case PhoneCallType.LEAD:
      positionLevel = 'کارشناس فروش'
      break
    case PhoneCallType.SOURCE:
      positionLevel = 'کارشناس خرید'
  }
  const gtTypes = selectedProductTypes.filter(
    (item) => item.selectedValue === 'gt'
  )
  const eqTypes = selectedProductTypes.filter(
    (item) => item.selectedValue === 'eq'
  )
  const ltTypes = selectedProductTypes.filter(
    (item) => item.selectedValue === 'lt'
  )
  const otherTypes = selectedProductTypes.filter((item) => !item.selectedValue)
  const selectedProductsTeams = union([
    ...gtTypes.map((item) => item.team),
    ...eqTypes.map((item) => item.team),
    ...ltTypes.map((item) => item.team),
    ...otherTypes.map((item) => item.team),
  ])
  let _operators: OperatorExtension[] = []

  if (selectedProductsTeams.length) {
    for (const team of selectedProductsTeams) {
      _operators = _operators.concat(
        sortOperators(
          operators.filter(
            (item) =>
              item.teamName === team && item.userPositionLevel === positionLevel
          )
        )
      )
    }

    for (const team of selectedProductsTeams) {
      _operators = _operators.concat(
        sortOperators(
          operators.filter(
            (item) =>
              item.teamName === team && item.userPositionLevel !== positionLevel
          )
        )
      )
    }

    for (const {} of selectedProductsTeams) {
      _operators = _operators.concat(
        operators.filter((item) => item.userPositionLevel === positionLevel)
      )
    }
  } else {
    _operators = _operators.concat(
      operators.filter((item) => item.userPositionLevel === positionLevel)
    )
  }

  return union(_operators, operators)
}
